/**
 * Stable path fragment used in all backend-served file proxy URLs.
 * Relative URLs are always used, so no domain check is needed — external URLs
 * will never contain this path fragment with a local file UUID.
 *
 * Pattern: /attachments/{uuid}/
 */
const FILE_ATTACHMENT_REGEX_SOURCE =
  '/attachments/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/';

/** Exported constant for use in documentation / tests. */
export const FILE_ATTACHMENT_REGEX = new RegExp(FILE_ATTACHMENT_REGEX_SOURCE, 'gi');

/**
 * Scan `content` for file references matching `/attachments/{uuid}/` and
 * return a deduplicated array of UUID strings (lowercase).
 * Returns `[]` when no matches are found.
 */
export function extractFileIdsFromContent(content: string): string[] {
  // Create a fresh RegExp each call — a shared /g regex retains lastIndex state.
  const regex = new RegExp(FILE_ATTACHMENT_REGEX_SOURCE, 'gi');
  const seen = new Set<string>();
  let match: RegExpExecArray | null;

  while ((match = regex.exec(content)) !== null) {
    seen.add(match[1].toLowerCase());
  }

  return Array.from(seen);
}

